/**
 * The two call modes a meeting can start in, decided server-side per meeting
 * (backend-feathub#171). `mountMeeting()` uses this to decide whether to
 * request video by default — audio-only never disables the camera control,
 * it just doesn't turn it on automatically (issue #8).
 */
export type CallType = "video" | "audio";

/**
 * Normalizes a raw (possibly missing/malformed) `callType` value coming from
 * a join-response body or a URL query param. Anything other than exactly
 * `"audio"` defaults to `"video"`, matching the video-call-by-default
 * behavior this app has always had.
 */
export function parseCallType(raw: unknown): CallType {
  return raw === "audio" ? "audio" : "video";
}

/**
 * Pure decision for `mountMeeting()`'s `defaults.video`: off only for
 * audio-only calls, on otherwise. Never touches `defaults.audio` or any
 * RealtimeKit preset/permission — the camera control stays visible and
 * functional regardless, this only decides what starts active.
 */
export function resolveVideoDefault(callType: CallType): boolean {
  return callType !== "audio";
}
